import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class ProfileMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ProfileMetaModule,
            providers: [
                providePageMeta({
                    title: 'Profile',
                    translationKey: 'page_profile',
                    routerLink: '/profile/:id',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Profile',
                    translationKey: 'page_profile',
                    routerLink: '/host/profile/:id',
                    category: PageCategory.Host,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
